import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../store';
// utils
import { AxiosResponse } from 'axios';
import baseService from '../../services/base.service';

type RecordPagination = {
  page: number;
  limit: number;
};

type RecordState = {
  isLoading: boolean;
  error: boolean;
  data: {
    result: [];
    pager: {
      pageNumber: number;
      pageSize: number;
      totalRecords: number;
      totalPages: number;
    };
  };
};

const initialState: RecordState = {
  isLoading: false,
  error: false,
  data: {
    result: [],
    pager: {
      pageNumber: 1,
      pageSize: 10,
      totalRecords: 0,
      totalPages: 1
    }
  }
};
const slice = createSlice({
  name: 'idea',
  initialState,
  reducers: {
    getRecordsById(state, action) {
      state.data = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

export function getRecords(recordPagination?: RecordPagination, companyId?: number) {
  return async () => {
    try {
      const query = `PageNumber=${recordPagination?.page || 1}&PageSize=${
        recordPagination?.limit || 8
      }&companyId=${companyId}`;
      const response: AxiosResponse = await baseService.get(`/record/company?${query}`);
      dispatch(slice.actions.getRecordsById(response?.data?.data));
    } catch (error) {}
  };
}
